import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SendIcon from "@mui/icons-material/Send";
import { Box, Divider, IconButton } from "@mui/material";
import type { FC, MouseEvent } from "react";
import { INK } from "../../../../theme/tokens";
import { InHouseTooltip } from "../../../InHouseTooltip/InHouseTooltip";
import type { TabType } from "../../../StaffingChanges/StaffingChanges";

interface IProps {
	onTabOpen: (tab: TabType) => void;
	/** Marks this card's Post Shift button as the Annie walkthrough anchor. Set on one card per week. */
	isPostShiftAnchor?: boolean;
}

export const DayQuickActions: FC<IProps> = ({ onTabOpen, isPostShiftAnchor }) => {
	const handleClick = (e: MouseEvent, tab: TabType): void => {
		e.stopPropagation();
		e.preventDefault();
		onTabOpen(tab);
	};

	return (
		<Box sx={{ px: 1 }}>
			<Box sx={{ display: "flex", alignItems: "center", gap: 0.5, height: "36px" }}>
				<InHouseTooltip title="Post Shift">
					<IconButton
						data-testid="staffing-create-shift-button"
						// Only the card the week picked as the anchor: this row repeats once per day, and an anchor
						// has to be a single element. Paired with the v1 grid's Edit Staff pencil, which opens the
						// same panel — the two grids are mutually exclusive branches of one route.
						data-annie-target={isPostShiftAnchor ? "staffing-post-shift" : undefined}
						size="small"
						onClick={(e) => handleClick(e, "create-shift")}
						sx={{ color: "primary.main", "&:hover": { color: INK.SECONDARY } }}
					>
						<SendIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</InHouseTooltip>
				<InHouseTooltip title="Add to Schedule">
					<IconButton
						data-testid="staffing-add-nurse-button"
						size="small"
						onClick={(e) => handleClick(e, "add-nurse")}
						sx={{ color: "primary.main", "&:hover": { color: INK.SECONDARY } }}
					>
						<PersonAddIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</InHouseTooltip>
				<InHouseTooltip title="Remove from Schedule">
					<IconButton
						data-testid="staffing-remove-nurse-button"
						size="small"
						onClick={(e) => handleClick(e, "remove-nurse")}
						sx={{ color: "primary.main", "&:hover": { color: INK.SECONDARY } }}
					>
						<DeleteOutlineIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</InHouseTooltip>
			</Box>
			<Divider />
		</Box>
	);
};
